/**
 * @desc 查询中台系统包裹单发货信息表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/systemOrderPackage/getDeliveryInformation`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
